import { IRequesterInfo } from '../../../base/models'
import { ClientProxy } from '../../../base/proxy/clientProxy'
import { ICampaignsProducts, IProductSuggestionAI } from '../commonModels/models'

export class GetAISuggestionApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'homepage/ai-suggest',
      requesterInfo,
    })
  }

  public async getSuggest(): Promise<IProductSuggestionAI> {
    return await this.getAsync<IProductSuggestionAI>()
  }
}
